import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { fromJSX } from 'widgets-for-react';
export const useEffect = (effect, deps, options)=>fromJSX((setState)=>/*#__PURE__*/ _jsx(UseEffect, {
            effect: ()=>effect(setState),
            deps: deps
        }, options === null || options === void 0 ? void 0 : options.key));
const UseEffect = (param)=>{
    let { effect, deps } = param;
    React.useEffect(effect, deps);
    return /*#__PURE__*/ _jsx(React.Fragment, {});
};
